
export const getWalrPlatformLink = (projectId: string, datasetId:string )=>{
    return  `https://platform.walr.com/projects/${projectId}/${datasetId}/analyze/datasets`;
}

export const getForstVizPlaformLink = ()=>{
    return "https://dc.dapresy.com/";
}
